import { render, staticRenderFns } from "./Telecom.vue?vue&type=template&id=3e8df882&scoped=true"
import script from "./Telecom.vue?vue&type=script&lang=js"
export * from "./Telecom.vue?vue&type=script&lang=js"
import style0 from "./Telecom.vue?vue&type=style&index=0&id=3e8df882&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8df882",
  null
  
)

export default component.exports